var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ModalModule, TabsModule, TooltipModule } from 'ngx-bootstrap';
import { GuiComponent } from './gui/gui.component';
import { DefaultLocalization, LOCALIZATION } from './localization/localization.service';
import { AlertModalComponent } from './modal/alert/alert-modal.component';
import { ConfirmOperationModalComponent } from './modal/confirm-operation/confirm-operation-modal.component';
import { WriteCharacterModalComponent } from './modal/write-character/write-character-modal.component';
import { WriteValueModalComponent } from './modal/write-value/write-value-modal.component';
import { GlobalSettings } from './settings/global-settings';
import { AccessPermissionService } from './utils/access-permission.service';
import { AutoFocusDirective } from './utils/auto-focus.directive';
import { BsModalDragDirective } from './utils/bs-modal-drag.directive';
import { DataTypeService } from './utils/data-type/data-type.service';
import { FractionDigitService } from './utils/fraction-digit.service';
import { NumericalOperationService } from './utils/numerical-operation.service';
import { ViewService } from './view/view.service';
import { ConsoleLoggerService, LOGGER_SERVICE_TOKEN } from './logger';
import { VerifyPasswordModalComponent } from './modal/verify-password/verify-password-modal.component';
import { FBoxDataTypeService } from './utils/data-type/fbox-data-type.service';
import { FCloudDataTypeService } from './utils/data-type/fcloud-data-type.service';
const ɵ0 = DefaultLocalization;
let GuiModule = class GuiModule {
};
GuiModule = __decorate([
    NgModule({
        imports: [
            CommonModule,
            FormsModule,
            ModalModule.forRoot(),
            TabsModule,
            TooltipModule
        ],
        declarations: [
            GuiComponent,
            WriteValueModalComponent,
            ConfirmOperationModalComponent,
            WriteCharacterModalComponent,
            AlertModalComponent,
            AutoFocusDirective,
            BsModalDragDirective,
            VerifyPasswordModalComponent
        ],
        exports: [
            GuiComponent,
            BsModalDragDirective,
            AutoFocusDirective
        ],
        providers: [
            FractionDigitService,
            FBoxDataTypeService,
            FCloudDataTypeService,
            DataTypeService,
            AccessPermissionService,
            NumericalOperationService,
            { provide: LOCALIZATION, useValue: ɵ0 },
            { provide: LOGGER_SERVICE_TOKEN, useClass: ConsoleLoggerService },
            ViewService,
            GlobalSettings
        ],
        entryComponents: [
            ConfirmOperationModalComponent,
            AlertModalComponent,
            WriteValueModalComponent,
            WriteCharacterModalComponent,
            VerifyPasswordModalComponent
        ]
    })
], GuiModule);
export { GuiModule };
export { ɵ0 };
